var _g, _g2, _g3, _g4, _g5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsTools(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_3_imagine",
    "data-name": "3 imagine",
    xmlns: "http://www.w3.org/2000/svg",
    width: 149.384,
    height: 133.727,
    viewBox: "0 0 149.384 133.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351",
    transform: "translate(0 46.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M-210.486,196.684c-.043.874-.6,1.552-1.242,1.519l-6.169-.31c-.647-.036-1.127-.765-1.084-1.639l.249-4.965c.048-.876.609-1.557,1.254-1.523l6.158.312c.643.032,1.129.763,1.086,1.641Z",
    transform: "translate(246.856 -189.764)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M-211.432,215.282c.043-.874-.446-1.609-1.084-1.638l-6.165-.306c-.645-.041-1.206.645-1.249,1.514l-.249,4.972c-.043.869.437,1.6,1.084,1.636l6.172.308c.643.036,1.2-.643,1.238-1.514Z",
    transform: "translate(245.342 -159.99)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M-215.23,196.052a1.415,1.415,0,0,1-.321,1.933l-5.5,2.811a1.421,1.421,0,0,1-1.756-.874l-2.265-4.429a1.426,1.426,0,0,1,.312-1.94l5.5-2.806a1.411,1.411,0,0,1,1.761.869Z",
    transform: "translate(238.881 -188.652)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M-206.747,212.634a1.421,1.421,0,0,0-1.761-.883L-214,214.564a1.427,1.427,0,0,0-.326,1.944l2.268,4.424a1.424,1.424,0,0,0,1.763.878L-204.8,219a1.435,1.435,0,0,0,.319-1.946Z",
    transform: "translate(252.457 -162.115)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M-220.238,197.713a1.424,1.424,0,0,1,.7,1.838l-3.358,5.183a1.428,1.428,0,0,1-1.967.122l-4.166-2.7a1.417,1.417,0,0,1-.693-1.835l3.352-5.187a1.419,1.419,0,0,1,1.958-.12Z",
    transform: "translate(233.107 -183.549)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M-204.6,207.828a1.421,1.421,0,0,0-1.958.122l-3.349,5.185a1.414,1.414,0,0,0,.69,1.84l4.173,2.7a1.427,1.427,0,0,0,1.969-.122l3.343-5.18a1.41,1.41,0,0,0-.69-1.838Z",
    transform: "translate(258.133 -167.353)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M-224.382,201.135c.876.045,1.562.6,1.53,1.245l-.321,6.165c-.032.645-.765,1.129-1.632,1.086l-4.974-.251c-.876-.048-1.552-.6-1.519-1.251l.31-6.156c.036-.65.765-1.134,1.641-1.086Z",
    transform: "translate(231.3 -175.721)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M-205.773,202.084c-.876-.045-1.614.439-1.643,1.082l-.312,6.163c-.034.645.647,1.209,1.523,1.247l4.965.256c.876.041,1.607-.441,1.639-1.089l.315-6.163c.036-.647-.652-1.2-1.521-1.249Z",
    transform: "translate(261.072 -174.207)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M-225.014,206.741a1.424,1.424,0,0,1,1.937.317l2.811,5.495a1.427,1.427,0,0,1-.876,1.763l-4.429,2.263a1.427,1.427,0,0,1-1.942-.319l-2.809-5.493a1.427,1.427,0,0,1,.876-1.763Z",
    transform: "translate(232.412 -168.605)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M-208.435,198.259a1.424,1.424,0,0,0-.876,1.759l2.811,5.493a1.417,1.417,0,0,0,1.939.321l4.429-2.263a1.421,1.421,0,0,0,.871-1.761l-2.809-5.5a1.424,1.424,0,0,0-1.94-.319Z",
    transform: "translate(258.952 -182.182)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M-223.355,211.847a1.43,1.43,0,0,1,1.844-.7l5.18,3.349a1.427,1.427,0,0,1,.12,1.969l-2.7,4.18a1.419,1.419,0,0,1-1.84.686l-5.183-3.352a1.422,1.422,0,0,1-.122-1.958Z",
    transform: "translate(237.516 -162.932)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M-213.235,196.206a1.423,1.423,0,0,0,.127,1.964l5.185,3.349a1.416,1.416,0,0,0,1.833-.69l2.7-4.176a1.429,1.429,0,0,0-.122-1.964l-5.18-3.354a1.438,1.438,0,0,0-1.847.69Z",
    transform: "translate(253.712 -187.958)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M-201.81,191.953a26.012,26.012,0,0,0-27.3,24.659,26.016,26.016,0,0,0,24.661,27.3,26.017,26.017,0,0,0,27.3-24.664A26.007,26.007,0,0,0-201.81,191.953ZM-204,235.037a17.127,17.127,0,0,1-16.243-17.972,17.129,17.129,0,0,1,17.976-16.236A17.118,17.118,0,0,1-186.024,218.8,17.115,17.115,0,0,1-204,235.037Z",
    transform: "translate(234.022 -187.043)",
    fill: "#768296"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352",
    transform: "translate(18.198 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M-209.7,173.789c-.025.568-.387,1.012-.808.991l-4.019-.2c-.421-.025-.738-.5-.708-1.068l.165-3.234c.027-.573.394-1.014.812-.991l4.017.2c.416.023.733.5.7,1.068Z",
    transform: "translate(233.396 -169.283)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M-210.31,185.91c.027-.566-.292-1.048-.711-1.068l-4.015-.2c-.419-.025-.788.421-.812.989l-.163,3.239c-.027.566.283,1.043.706,1.066l4.019.2c.419.025.783-.421.808-.987Z",
    transform: "translate(232.41 -149.882)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M-212.79,173.378a.918.918,0,0,1-.208,1.261l-3.578,1.831a.932.932,0,0,1-1.147-.57l-1.476-2.888a.93.93,0,0,1,.2-1.261l3.585-1.831a.921.921,0,0,1,1.145.568Z",
    transform: "translate(228.2 -168.559)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M-207.261,184.187a.929.929,0,0,0-1.145-.579l-3.578,1.835a.928.928,0,0,0-.215,1.265l1.476,2.886a.935.935,0,0,0,1.152.573l3.583-1.835a.927.927,0,0,0,.206-1.263Z",
    transform: "translate(237.047 -151.266)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M-216.049,174.462a.928.928,0,0,1,.455,1.2l-2.186,3.377a.932.932,0,0,1-1.283.079l-2.713-1.763a.92.92,0,0,1-.453-1.195l2.184-3.383a.927.927,0,0,1,1.274-.075Z",
    transform: "translate(224.437 -165.233)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M-205.857,181.052a.932.932,0,0,0-1.276.079l-2.186,3.381a.924.924,0,0,0,.45,1.2l2.72,1.758a.938.938,0,0,0,1.285-.081l2.177-3.374a.929.929,0,0,0-.45-1.2Z",
    transform: "translate(240.744 -154.679)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M-218.749,176.69c.57.029,1.021.4.994.815l-.206,4.015c-.02.419-.5.738-1.064.711l-3.239-.165c-.57-.032-1.014-.394-.993-.815l.2-4.015c.023-.421.5-.736,1.07-.706Z",
    transform: "translate(223.258 -160.132)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M-206.625,177.31c-.57-.032-1.052.283-1.068.7l-.2,4.015c-.025.421.419.79.991.813l3.236.17c.566.027,1.046-.292,1.068-.713l.2-4.015c.023-.419-.423-.783-.991-.815Z",
    transform: "translate(242.661 -159.145)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M-219.163,180.345a.93.93,0,0,1,1.265.206l1.829,3.58a.93.93,0,0,1-.57,1.15l-2.888,1.473a.931.931,0,0,1-1.267-.208l-1.824-3.58a.92.92,0,0,1,.57-1.145Z",
    transform: "translate(223.984 -155.495)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M-208.36,174.816a.936.936,0,0,0-.57,1.15l1.831,3.576a.929.929,0,0,0,1.263.213l2.89-1.476a.93.93,0,0,0,.568-1.15l-1.829-3.578a.923.923,0,0,0-1.263-.21Z",
    transform: "translate(241.278 -164.343)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M-218.08,183.669a.934.934,0,0,1,1.2-.453l3.377,2.186a.929.929,0,0,1,.079,1.279l-1.761,2.725a.931.931,0,0,1-1.2.448l-3.372-2.184a.924.924,0,0,1-.081-1.276Z",
    transform: "translate(227.31 -151.799)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M-211.484,173.476a.926.926,0,0,0,.082,1.281l3.377,2.186a.923.923,0,0,0,1.195-.45l1.763-2.725a.925.925,0,0,0-.081-1.276l-3.372-2.186a.938.938,0,0,0-1.2.453Z",
    transform: "translate(237.864 -168.107)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M-204.042,170.707a16.949,16.949,0,0,0-17.788,16.071,16.95,16.95,0,0,0,16.068,17.793A16.954,16.954,0,0,0-187.974,188.5,16.946,16.946,0,0,0-204.042,170.707Zm-1.426,28.079a11.164,11.164,0,0,1-10.582-11.714,11.168,11.168,0,0,1,11.714-10.582A11.16,11.16,0,0,1-193.754,188.2,11.158,11.158,0,0,1-205.468,198.786Z",
    transform: "translate(225.034 -167.511)",
    fill: "#768296"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    transform: "translate(104.886 44.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M-173.759,192.7c-.023.471-.321.835-.665.817l-3.32-.165c-.351-.02-.609-.412-.586-.883l.14-2.668c.018-.471.324-.837.67-.819l3.311.167c.346.018.609.407.584.883Z",
    transform: "translate(193.32 -188.986)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M-174.266,202.713c.018-.468-.247-.867-.586-.885l-3.315-.167c-.346-.016-.647.351-.672.819l-.134,2.673c-.025.466.233.862.584.88l3.318.165c.344.018.643-.344.665-.815Z",
    transform: "translate(192.507 -172.977)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M-176.315,192.362a.761.761,0,0,1-.167,1.043l-2.956,1.509a.769.769,0,0,1-.948-.466l-1.22-2.385a.767.767,0,0,1,.172-1.041l2.958-1.507c.308-.165.731.052.944.466Z",
    transform: "translate(189.032 -188.387)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M-171.751,201.284a.763.763,0,0,0-.944-.475l-2.953,1.514a.763.763,0,0,0-.179,1.043l1.22,2.381a.767.767,0,0,0,.951.473l2.953-1.512a.773.773,0,0,0,.17-1.048Z",
    transform: "translate(196.333 -174.117)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M-179,193.262a.764.764,0,0,1,.373.984l-1.806,2.79a.765.765,0,0,1-1.057.066l-2.243-1.457a.761.761,0,0,1-.371-.989l1.8-2.786a.76.76,0,0,1,1.052-.063Z",
    transform: "translate(185.927 -185.644)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M-170.594,198.7a.77.77,0,0,0-1.057.066l-1.8,2.788a.764.764,0,0,0,.369.991l2.245,1.451a.774.774,0,0,0,1.064-.066l1.8-2.788a.768.768,0,0,0-.373-.987Z",
    transform: "translate(199.386 -176.934)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M-181.231,195.1c.471.025.84.324.819.67l-.167,3.313a.77.77,0,0,1-.88.586l-2.675-.136c-.473-.027-.835-.326-.819-.674l.172-3.309c.014-.349.41-.611.88-.586Z",
    transform: "translate(184.954 -181.434)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M-171.222,195.61c-.475-.023-.874.235-.887.582l-.167,3.313c-.018.351.346.652.819.672l2.668.138c.471.02.865-.238.883-.584l.17-3.316c.016-.346-.353-.647-.822-.674Z",
    transform: "translate(200.967 -180.62)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M-181.578,198.114a.773.773,0,0,1,1.048.172l1.507,2.956c.161.31-.05.729-.468.948l-2.385,1.215a.765.765,0,0,1-1.043-.17l-1.507-2.956a.762.762,0,0,1,.468-.944Z",
    transform: "translate(185.555 -177.607)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M-172.658,193.552a.77.77,0,0,0-.471.948l1.512,2.951a.76.76,0,0,0,1.041.174l2.388-1.218a.76.76,0,0,0,.464-.946l-1.509-2.958a.764.764,0,0,0-1.041-.17Z",
    transform: "translate(199.826 -184.909)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M-180.682,200.859a.77.77,0,0,1,.994-.371l2.786,1.8a.764.764,0,0,1,.066,1.057l-1.453,2.25a.771.771,0,0,1-1,.369l-2.779-1.8a.756.756,0,0,1-.068-1.052Z",
    transform: "translate(188.298 -174.556)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M-175.24,192.449a.773.773,0,0,0,.068,1.057l2.788,1.8a.758.758,0,0,0,.984-.371l1.455-2.245a.77.77,0,0,0-.063-1.057l-2.79-1.8a.761.761,0,0,0-.987.369Z",
    transform: "translate(197.009 -188.015)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M-169.1,190.162a13.986,13.986,0,0,0-14.679,13.262,13.99,13.99,0,0,0,13.26,14.683,13.99,13.99,0,0,0,14.681-13.267A13.986,13.986,0,0,0-169.1,190.162Zm-1.177,23.168a9.208,9.208,0,0,1-8.733-9.661,9.222,9.222,0,0,1,9.67-8.736,9.209,9.209,0,0,1,8.731,9.668A9.2,9.2,0,0,1-170.274,213.33Z",
    transform: "translate(186.42 -187.523)",
    fill: "#768296"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(36.15 6.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M-210.4,219.121-183.042,202-208.4,181.992A32.282,32.282,0,0,0-210.4,219.121Z",
    transform: "translate(215.326 -159.761)",
    fill: "#fcd751"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M-205.478,174.512l12.058,29.944,23.46-22.149a32.18,32.18,0,0,0-3.451-3.209A32.259,32.259,0,0,0-205.478,174.512Z",
    transform: "translate(227.766 -172.169)",
    fill: "#1c4670"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M-205.8,216.192A32.112,32.112,0,0,0-183.169,223l-2.623-32.171-27.357,17.121A32.171,32.171,0,0,0-205.8,216.192Z",
    transform: "translate(218.077 -148.593)",
    fill: "#1c4670"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M-212.266,187.536l25.358,20.008L-198.97,177.6A32.12,32.12,0,0,0-212.266,187.536Z",
    transform: "translate(219.192 -165.305)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M-201.061,203.2l31.046,8.833a32.323,32.323,0,0,0-7.586-30.982Z",
    transform: "translate(233.345 -160.956)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M-201.061,190.833-198.438,223a32.5,32.5,0,0,0,10.668-2.75,32.077,32.077,0,0,0,12.065-9.412,32.111,32.111,0,0,0,5.69-11.175Z",
    transform: "translate(233.345 -148.593)",
    fill: "#72beb7"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    transform: "translate(49.173 33.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355",
    transform: "translate(44.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M-162.05,239.863a27.692,27.692,0,0,1-19.716-8.165,27.694,27.694,0,0,1-8.168-19.719,27.692,27.692,0,0,1,8.168-19.716,27.69,27.69,0,0,1,19.719-8.168,27.709,27.709,0,0,1,19.719,8.165,27.7,27.7,0,0,1,8.163,19.719,27.7,27.7,0,0,1-8.168,19.719A27.7,27.7,0,0,1-162.05,239.863Zm0-49.948a21.914,21.914,0,0,0-15.6,6.461,21.913,21.913,0,0,0-6.464,15.6,21.906,21.906,0,0,0,6.464,15.6,21.906,21.906,0,0,0,15.6,6.464,21.914,21.914,0,0,0,15.6-6.464,21.917,21.917,0,0,0,6.466-15.6,21.932,21.932,0,0,0-6.461-15.6A21.926,21.926,0,0,0-162.048,189.916Z",
    transform: "translate(189.934 -184.095)",
    fill: "#1c4670"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(39.508 43.152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 19.001,
    height: 5.822,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 13.434)",
    fill: "#1c4670"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    d: "M1.715,0H56.5a1.716,1.716,0,0,1,1.716,1.716v9.666A1.715,1.715,0,0,1,56.5,13.1H1.714A1.714,1.714,0,0,1,0,11.382V1.715A1.715,1.715,0,0,1,1.715,0Z",
    transform: "translate(0 90.942) rotate(-44.984)",
    fill: "#aebfce"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(34.191 55.388)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 1.941,
    height: 13.097,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 1.372)",
    fill: "#72beb7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(30.99 58.59)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 1.94,
    height: 13.097,
    transform: "translate(0 1.371) rotate(-44.994)",
    fill: "#72beb7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359",
    transform: "translate(5.605 83.973)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 1.942,
    height: 13.098,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 1.374)",
    fill: "#72beb7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(8.808 80.771)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 1.939,
    height: 13.098,
    transform: "translate(0 1.371) rotate(-45.007)",
    fill: "#72beb7"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsTools);
export default __webpack_public_path__ + "static/media/settingsTools.65133abb6842c7a8f824b182b8270bfd.svg";
export { ForwardRef as ReactComponent };